import { func, shape, string } from 'prop-types';
import React, { PureComponent } from 'react';

import {
  C,
  LAYOUT,
  SHAPE,
  runsOnExternalDomain,
} from './common';
import { Info, Story, Stories } from './containers';
import { Loading } from './components';
import { Consumer, Provider } from './context';
import { ENV, LAYOUT as REACTOR } from './reactor/common';
import { BoardingPass, LayoutView } from './reactor/components';
import styles from './App.style';

const { LANGUAGE } = C;
const { IS_SERVER } = ENV;

class App extends PureComponent {
  static propTypes = {
    language: string,
    onBack: func,
    onUri: func,
    session: shape(SHAPE.SESSION),
    story: string,
    userAgent: string,
    serverRequest: shape({}),
  };

  static defaultProps = {
    language: LANGUAGE,
    onBack: undefined,
    onUri: undefined,
    session: {},
    story: undefined,
    userAgent: undefined,
    serverRequest: undefined,
  };

  constructor(props) {
    super(props);
    const { userAgent, serverRequest, language } = this.props;
    if (userAgent) REACTOR.calc(undefined, userAgent);
    const onExternalDomain = runsOnExternalDomain(serverRequest, language);
    this.state = { reload: false, onExternalDomain };
  }

  async componentWillReceiveProps({ story: nextStory }) {
    const { props: { story } } = this;
    this.setState({
      reload: nextStory !== story,
    });
  }

  _onError = (error) => {
    this.setState({ reload: false });
    console.log('ERROR', error);
  }

  _onDataSource = (reload, response, { onDataSource, onStories }) => {
    const { onExternalDomain } = this.state;
    this.setState({ reload: false });
    onDataSource({ onExternalDomain, ...response });
    if (reload) onStories();
  }

  _onLayout = () => {
    LAYOUT.calc();
  }

  render() {
    const {
      _onDataSource, _onError, _onLayout,
      props: { language, story, ...inherit },
      state: { reload },
    } = this;

    return (
      <Provider {...inherit}>
        <LayoutView
          onLayout={_onLayout}
          style={[styles.app, { height: IS_SERVER ? '100vh' : REACTOR.VIEWPORT.H }]}
        >
          <Consumer>
            { ({
              dataSource, stories, info, ...context
            }) => (
              <BoardingPass
                enabled={!IS_SERVER}
                loading={<Loading />}
                onError={_onError}
                onResponse={response => _onDataSource(reload, response, context)}
                reload={reload}
                service={`stories/retrieve?uri=${story}&language=${language}`}
              >
                <Stories visible={stories} />
                { !IS_SERVER && <Info visible={info !== undefined} /> }
                <Story dataSource={dataSource} visible={!stories && !info} />
              </BoardingPass>
            )}
          </Consumer>
        </LayoutView>
      </Provider>
    );
  }
}

export default App;
